export const HEADER_NAV_LINKS: Record<string, string> = {
	About: '/about',
	Projects: '/projects',
	Settings: '/settings/vscode',
	'Minecraft Mods': '/minecraft',
	Pomodoro: '/pomodoro',
};
